export default {
    "ins_1": " Ҳурматли мижоз, картага пул олиш учун қуйидаги кўрсатмаларга амал қилинг:",
    "ins_1_1": "Шахсий ҳисоб қайдномангизни ва туғилган кунингизни киритинг ",
    "ins_2": "Шахсий ҳисобингизни \"Ҳамкорлар орқали микрокредитларни қайтариш усуллари\" ҳужжатидан ёки М Булакдаги мутахассисингиздан билиб олишингиз мумкин.",
    "ins_3": " Агар сиз киритган маълумотлар тўғри бўлса, «Кейинги» ни босинг",
    "warn": "ДИҚҚАТ!",
    "warn_1": " Агар хабарда Сизнинг исми-шарифингиз кўрсатилмаган бўлмаса, М Булакдаги мутахассис билан боғланинг.",
    "warn_2": " Агар сиз ушбу хабарни билмай очган бўлсангиз, илтимос, уни эътиборсиз қолдиринг ва ҳеч қандай маълумотни киритманг.",
    "warn_3": " Агар сиз кўрсатмаларга қатъий риоя қилсангиз ва ҳамма нарсани тўғри киритган бўлсангиз, лекин телефон рақамингизга Код келмаган бўлса, М Булакдаги мутахассисингизга мурожаат қилинг.",
    "warn_4": " Агар сиз ҳамма нарсани тўғри ва тўлиқ бажарган бўлсангиз, сиз киритган маълумотларнинг тўғрилигини тасдиқлаш учун сиз киритган картадан 1 рубл ечиб олинади.  Операцияни тасдиқлаганингиздан сўнг 10 дақиқа ичида сизнинг картангизга 1 рубл қайтарилади.",
    "birthday": " Туғилган санангизни киритинг",
    "account": " Шахсий ҳисоб",
    "digit_range": " 2 дан 5 гача рақамлар",
    "next": "Кейин",
    "field_required": "Илтимос, ушбу қаторни тўлдиринг",
    "operation_failure": "Амалиёт муваффақиятли якунланмади",
    "processing": "Жараён кетмоқда",
    "continue": "Давом этинг",
    "enter_code": "Кодни киритинг",
    "page_not_found": "Саҳифа топилмади",
    "my_docs": "Менинг ҳужжатларим",
    "close": "Ёпиш",
    "credit_card": {
        "card_number": "Картани номери",
        "card_expiration_date": "Амал қилиш муддати",
        "check": "Текшириш",
        "submit": "Тасдиқланг"
    },
    "repay": {
      "h3": "Диққат:",
      "h4_title": "Диққат:",
      "h4_subtitle": "Тўлов дарҳол ҳисобга олинмайди,: жадвалдаги санадан 2-3 кун олдин тўланг",
      "h4_subtitle_2": "М Булак тўловлар учун комиссия олмайди. Ҳар қандай комиссия сизнинг банкингизнинг комиссиясидир.",
      "h4_subtitle_3": "Шунингдек, эслатиб ўтамизки, тўлов дарҳол қабул қилинмайди ва банк томонидан бир неча кун давомида ишланиши мумкин.",
      "h4_subtitle_4": "Кечиктирилган тўловларга ёъл қўймаслик учун олдиндан тўланг.",
        "birthday": "Туғилган кун",
        "account": "Шахсий ҳисоб",
        "amount": "Тўлов миқдори",
        "to_main_site": "Бош саҳифага",
        "check": "Текшириш ",
        "loans": "Насиялар",
        "payment": "Тўлов",
        "forgot": "Унутдингизми?",
        "title": "Онлайн кредитни тўлаш",
        "modal": {
            "header": "Шахсий ҳисобингизни қандай билиш мумкин?",
            "p1": "Агар сиз шахсий ҳисобингизни унутган бўлсангиз, Компанияда рўйхатдан ўтган мобил телефонингиздан 8 (903) 76-76-000 рақамига «инфо» сўзи билан СМС-хабарни юборинг ва сиз шахсий ҳисоб рақамингизни СМС-хабар орқали оласиз.",
            "p2": "Шунингдек, кредит бериш ва тўловни амалга оширишда Компанияда рўйхатдан ўтган мобил телефон рақамингизга шахсий ҳисоб қайдномаси кўрсатилган хабар юборилади. «L/chet:XX»",
            "p3": "*СМС хабарнинг нархи операторингизнинг тариф режасига мувофиқ белгиланади."
        }
    },
    "user_docs": {
        "attach": "Илова қилинг",
        "processing": "Ҳужжат кўрилиб чиқмоқда",
        "page": "{1} Саҳифанинг {0} саҳифаси",
        "warning": "ДИҚҚАТ! Хужжатларни қистиришдан олдин текширинг: хужжатлардаги барча суратлар тиниқ ва яхши сифатда бўлсин! Нусхалар ҳам сифати талабга жавоб бермаса - қабул қилинмайди!"
    },
    "error_unexpected": "Кутилмаган хато юз берди",
    "doc_view": {
        "null": "Маълумотлар янгиланмаган"
    },
    "choose_loan": "Тўламоқчи бўлган шартномани танланг",
    "wrong_amount": "150 000 рублдан ортиқ бўлмаган миқдорни белгиланг"
};

export const validation = {
    required: "Бу мажбурий қатор",
    numeric: "Қатор рақамли бўлиши шарт",
    positive: "Қатор ижобий сонли бўлиши шарт",
    alpha: "Қатор харифли бўлиши шарт",
    invalid_email: "Электрон почта манзилининг формати нотўғри форматда",
    card_number: "Карта рақамлари нотўғри",
    invalid_date: "Сана нотўғри",
    card_expired: "Картанинг амал қилиш муддати тугаган",
    file_size: "{0} файл ҳажми рухсат этилган {1}мб чегарасидан ошиб кетди",
    file_type: "{0} файл тури нотўғри, булларнинг {1} ичидан бирини танланг",
    client_account: "Шаҳсий кабинетда 2 дан 5 тагача рақам бўлиши керак",
    repay_amount: "Тўлов миқдори 36 дан 1,000,000 рубильгача бўлиши керак",
    char_length: "Қаторнинг узунлиги {0} бўлиши керак",
    char_length_within: "Қаторнинг узунлиги {0} дан кам ва {1} дан ошиқ бўлиши керак",
};
